<template>
  <div v-if="value.meta">
    <el-divider />
      <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="8">
        <el-input-title>Weapon</el-input-title>
        <el-form-item prop="meta.weapon">
          <el-select class="mt-05" @change="handleSelectWeapon" v-model="selectedWeapon">
            <el-option
              v-for="weapon in weapons"
              :key="weapon"
              :label="weapon"
              :value="weapon"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="8">
        <el-input-title>Hand Dominance</el-input-title>
        <el-form-item prop="meta.handDominance">
          <el-select class="mt-05" @change="handleSelectDominance" v-model="selectedHandDominance">
            <el-option
              v-for="{value, label} in [{value: 'Left', label: 'Left'}, {value: 'Right', label: 'Right'}]"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="8">
        <!-- <el-input-title required>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-autocomplete
            class="mt-05"
            v-model="selectedClubName"
            :fetch-suggestions="searchClub"
            @select="handleSelectHomeClub"
            placeholder="Enter club name to start searching"
          ></el-autocomplete>
        </el-form-item> -->
        <el-input-title required>Home Club</el-input-title>
          <el-form-item prop="meta.homeClub">
            <el-select
              filterable
              remote
              reserve-keyword
              class="mt-05 w-100"
              v-model="selectedClubName.name"
              :remote-method="searchClub"
              @blur="refs.validateField('meta.homeClub')"
              @change="handleSelectHomeClub"
              placeholder="Select">
              <el-option
                v-for="item in clubs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <!-- Are you vaccinated? -->
      <!-- <el-col :span="24" :md="8" class="mt-20">
        <el-input-title required>Are you Fully Vaccinated - As required by the Chief Health Officer of Victoria?</el-input-title>
        <el-form-item prop="meta.vaccinated">
          <el-select class="mt-05" v-model="value.meta.vaccinated" @change="handleVaccinationStatus" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
          </el-select>
        </el-form-item>
      </el-col> -->
      <!-- <el-col v-if="value.meta.vaccinated" :span="24" :md="8" class="mt-20">
        <el-input-title >How many doses of covid vaccine have you taken?</el-input-title>
        <el-form-item prop="meta.vaccinationShot">
          <el-select class="mt-05" v-model="value.meta.vaccinationShot" placeholder="Select">
            <el-option v-for="e in vaccinationShotOptions" :label="e.name" :key="e.value" :value="e.value" />
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :span="24" :md="8" class="mt-20">
        <el-input-title required>Are you of Aboriginal and/or Torres Strait Islander origin?</el-input-title>
        <el-form-item prop="meta.isAboriginal">
          <el-select class="mt-05" v-model="value.meta.isAboriginal" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.name" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="8" class="mt-20">
        <el-input-title required>Do you wish to opt out of Fencing News?</el-input-title>
        <el-form-item prop="meta.newsOptOut">
          <el-select class="mt-05" v-model="value.meta.newsOptOut" placeholder="Yes / No">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'fencingExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      yesNoOptions: [
        {
          name: 'Yes',
          type: true,
        },
        {
          name: 'No',
          type: false,
        }
      ],
      vaccinationShotOptions: [
        {
          name: 'Single shot',
          value: '1',
        },
        {
          name: 'Double shots',
          value: '2',
        },
        {
          name: 'Three shots',
          value: '3',
        },
        {
          name: 'More than three shots',
          value: '3+',
        },
      ],
      weapons: [
        'Sabre',
        'Foil',
        'Epee',
      ],
      selectedWeapon: '',
      selectedHandDominance: '',
      selectedClubName: '',
      clubs: []
    };
  },
  mounted() {
    if (this.value.meta && this.value.meta.homeClub) this.selectedClubName = this.value.meta.homeClub;
    if (this.value.meta && this.value.meta.weapon) this.selectedWeapon = this.value.meta.weapon;
    if (this.value.meta && this.value.meta.handDominance) this.selectedHandDominance = this.value.meta.handDominance;
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
    handleVaccinationStatus() {
      if (!this.value.meta.vaccinated) {
        this.value.meta.vaccinationShot = '';
      }
    },
    handleSelectWeapon(selected) {
      this.value.meta.weapon = selected;
    },
    handleSelectDominance(selected) {
      this.value.meta.handDominance = selected;
    },
    handleSelectHomeClub(selected) {
      const club = this.clubs.find((c) => c.value === selected);
      this.selectedClubName = { name: club.value, _id: club._id };
      this.value.meta.homeClub = { name: club.value, _id: club._id };
    },
    searchClub(query) {
      this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: query }).then((res) => {
        const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
        // Append none
        data.unshift({ value: 'None', _id: 'none' });
        this.clubs = data;
      }).catch(() => {});
    },
  }
};
</script>

<style lang="scss" scoped>

.el-autocomplete,
.el-select,
.el-input {
  width: 100%;
}

</style>
